import { BiddingQuery } from '~/config/generated/graphql';

export const handleBiddingView = ({ auctionTipsModel }: BiddingQuery) => {
  return {
    header: auctionTipsModel?.header,
    auctionTipsList: auctionTipsModel?.auctionTipsList
  };
};
